import { themeStyle } from '@repo/ui/theming';

export const defaultTheme = {
  cursor: 'default',
  borderRadius: themeStyle.radiusLarge,
  shadow: themeStyle.varShadowMedium,
  maxWidth: '888px',
};
